import {Container} from "@mantine/core";
import {useNavigate, useSearchParams} from "react-router-dom";
import {dispatchSelector, useGetDispatchQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {ThemedPage} from "../../components/page/ThemedPage/ThemedPage";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {LoadingPage} from "../../components/page/LoadingPage/LoadingPage";
import {DispatchProfile} from "../../components/profile/DispatchProfile/DispatchProfile"
import {useTranslation} from "react-i18next";

type Props = {
    id?: string;
}

export const DispatchProfilePageRoute = () => {
    const [params, _setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const id = params.get("id") ?? undefined;

    const {t} = useTranslation(["common"])

    if (!id) {
        navigate(-1);
        return (
            <ErrorPage
                message={t("common.entity.dispatch", "Dispatch ") + " " + t("common.error.notfound", "Not Found")}/>
        );
    }

    return <DispatchProfilePage id={id}/>;
};

export const DispatchProfilePage = (props: Props) => {
    const {id} = props;

    const {t} = useTranslation(["common"])

    const selectDispatch = useMemo(() => {
        return dispatchSelector()
    }, []);

    const {dispatch, isFetching} = useGetDispatchQuery(id ?? skipToken, {
        selectFromResult: (result) => ({
            dispatch: selectDispatch(result),
            isFetching: result.isFetching
        })
    });

    if (isFetching) {
        return (
            <LoadingPage/>
        );
    }

    if (!dispatch) {
        return (
            <ErrorPage
                message={t("common.entity.dispatch", "Dispatch ") + " " + t("common.error.notfound", "Not Found")}/>
        );
    }

    return (
        <ThemedPage>
            {(classes) => (
                <Container className={classes.container} fluid={true} py="md">
                    <DispatchProfile dispatch={dispatch}/>
                </Container>
            )}
        </ThemedPage>
    );
};
